import React from 'react';

class BackgroundVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staticUrl: props.staticUrl,
      background_type: props.background_type,
      videoname: props.videoname,
      video_url: props.video_url,
    };
    this.videoPromise = null;
    this.backgroundRef = null;
    this.videoRef = null;
  }

  componentDidMount() {
    const { background_type } = this.props;
    const selected = background_type === 'video';

    if (selected)
      this.mountSources();
  }

  shouldComponentUpdate(nextProps) {
    const { staticUrl, background_type, videoname, video_url } = this.props;
    const selected = background_type === 'video';
    const bg = this.backgroundRef;
    const video = this.videoRef;

    if (background_type !== nextProps.background_type && nextProps.background_type === 'video') {  // OFF => ON
      this.mountSources(nextProps.videoname);

    } else if (background_type !== nextProps.background_type && this.props.background_type === 'video') {  // ON => OFF
      // this.videoPromise.then(() => {
      //   video.pause();
      // });
    } else if (background_type === 'video') {  // ON => ON
      if (videoname !== nextProps.videoname) { // videoname Change
        this.mountSources(nextProps.videoname);
        // const sources = video.getElementsByTagName('source');
        // let url = '';
        // // this.videoPromise.then(() => {
        // //   video.pause();
        // // });
        // video.setAttribute('poster', `${staticUrl}landbot/video/${nextProps.videoname}.jpg`);
        // for (let i = 0; i < sources.length; i++) {
        //   url = sources[i].getAttribute('src').replace(/(landbot\/video\/)(?:\w+)(\.mp4|\.webm)/g, `$1${nextProps.videoname}$2`);
        //   sources[i].setAttribute('src', url);
        // }
        // video.load();
        // video.play();
      }
    } else {  // OFF => OFF
      // Nothing
    }

    if (nextProps.background_type !== 'video')
      bg.className = bg.className.replace(/\sselected/g, '');
    else
      bg.className = 'hu-background-video' + ' selected';
    return false;
  }

  mountSources(videoname = this.props.videoname) {
    const { staticUrl, background_type, video_url } = this.props;
    const bg = this.backgroundRef;
    const video = this.videoRef;
    const sources = video.getElementsByTagName('source');
    let url = '';
    // this.videoPromise.then(() => {
    //   video.pause();
    // });
    video.setAttribute('poster', `${staticUrl}landbot/video/${videoname}.jpg`);
    for (let i = 0; i < sources.length; i++) {
      url = sources[i].getAttribute('data-src').replace(/(landbot\/video\/)(?:\w+)(\.mp4|\.webm)/g, `$1${videoname}$2`);
      sources[i].setAttribute('src', url);
    }
    video.load();
    video.play();
  }

  render() {
    const { staticUrl, background_type, videoname, video_url } = this.props;
    const selected = background_type === 'video';
    const overlay = (
      <div className="background-video-filter selected"></div>
    );

    if (video_url !== null)
      return (
        <div className={ selected ? 'hu-background-video selected' : 'hu-background-video' } ref={el => this.backgroundRef = el}>
          <video id='bgvid' playsInline autoPlay muted loop ref={el => {this.videoRef = el}}>
            <source src={video_url} type="video/mp4" />
          </video>
          {overlay}
        </div>
      );
    else
      return (
        <div className={ selected ? 'hu-background-video selected' : 'hu-background-video' } ref={el => this.backgroundRef = el}>
          <video id='bgvid' playsInline autoPlay muted loop poster={`${staticUrl}landbot/video/${videoname}.jpg`} ref={el => {this.videoRef = el}}>
            <source data-src={`${staticUrl}landbot/video/${videoname}.webm`} type="video/webm" />
            <source data-src={`${staticUrl}landbot/video/${videoname}.mp4`} type="video/mp4" />
          </video>
          {overlay}
        </div>
      );
  }
}

/*********** Not posible with REACT ***********
<!--[if lt IE 9]>
<script>document.createElement("video");</script>
<![endif]-->
***********************************************/

export default BackgroundVideo;


// WEBPACK FOOTER //
// ./app/js/components/background/BackgroundVideo.js